import type { Node } from '@xyflow/react'
import type { NodeCategory } from '@bandos/shared'
import type { ReactFlowNodeData } from '../types/mindmap-components'

/**
 * Generic function to update a node field
 * @param nodes - Current array of nodes
 * @param nodeId - ID of the node to update
 * @param field - Field name to update in node.data
 * @param value - New value for the field
 * @param category - Optional category filter (only update if node matches category)
 * @returns Updated array of nodes
 */
export function updateNodeField<T>(
  nodes: Node<ReactFlowNodeData>[],
  nodeId: string,
  field: keyof ReactFlowNodeData,
  value: T,
  category?: NodeCategory,
  userModified?: boolean
): Node<ReactFlowNodeData>[] {
  return nodes.map((node) => {
    if (node.id === nodeId) {
      // If category filter specified, only update if category matches
      if (category && node.data.category !== category) {
        return node
      }
      return {
        ...node,
        data: {
          ...node.data,
          [field]: value,
          ...(userModified ? { userModified: true } : {}),
        },
      }
    }
    return node
  })
}
